import axios from 'axios';

class MyCoursesApi {
  constructor() {
    this.processing = false;
    this.available_for_sharing = '/my-courses/available-for-sharing/';
  }

  availableForSharing(course_program_id) {
    const url = this.available_for_sharing + course_program_id;

    this.processing = true;

    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(({ data }) => {
          this.processing = false;
          resolve(data);
        })
        .catch(error => {
          this.processing = false;
          reject(error.response);
        });
    });
  }
}

export default MyCoursesApi;
